import { useState, useEffect } from "react";

// NOTE: UI-only recreation of the ERP register hook. The axios/CIAM/noser.dataaccess
// persistence has been intentionally removed. Field state and client-side validation
// are preserved so the form looks and validates exactly like the source.
const useForm = (callback) => {
  const [values] = useState({
    email: "",
    username: "",
    name: "",
    company: "",
    contact: "",
    address: "",
    password: "",
    confirm_password: "",
  });
  const [companyDDL] = useState([
    { name: "ALRAMA", id: "2", no: "200" },
    { name: "PRIME", id: "1", no: "100" },
  ]);
  const [selectedCompany] = useState([]);

  const [loading] = useState(false);
  const [errorVal] = useState("");
  const [errors, setErrors] = useState({});
  const [valueDataRegister] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [email, setemail] = useState("");
  const [company, setcompany] = useState("");
  const [companyno] = useState("");
  const [companyid] = useState("");
  const [companycode, setcompanycode] = useState("");
  const [userid, setuserid] = useState("");
  const [name, setname] = useState("");
  const [contact, setcontact] = useState("");
  const [address, setaddress] = useState("");
  const [password, setpassword] = useState("");
  const [confirm_password, setconfirm_password] = useState("");

  const handleChange = () => {};
  const handleChangeEmail = (e) => setemail(e.target.value);
  const handleChangeUserid = (e) => setuserid(e.target.value.replace(/['"/]/g, "").slice(0, 100));
  const handleChangeName = (e) => setname(e.target.value.replace(/['"/]/g, "").slice(0, 100));
  const companydropdown = (e) => setcompany(e.target.value.replace(/['"/]/g, "").slice(0, 100));
  const handleChangeContact = (e) => setcontact(e.target.value.replace(/\D/g, ""));
  const handleChangeAddress = (e) => setaddress(e.target.value.replace(/['"/]/g, "").slice(0, 100));
  const handleChangePassword = (e) => setpassword(e.target.value.replace(/['"/]/g, "").slice(0, 100));
  const handleChangeConfirmPassword = (e) =>
    setconfirm_password(e.target.value.replace(/['"/]/g, "").slice(0, 100));

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrors(validation());
    setIsSubmitting(true);
  };

  const validation = () => {
    let errs = {};
    valueDataRegister.forEach((item) => {
      if (item.email === email) errs.email = "email already exist";
      if (item.userid === userid) errs.username = "username already exist";
    });

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!email) {
      errs.email = "This field is required";
    } else if (!pattern.test(email)) {
      errs.email = "Email address is invalid";
    }
    if (!userid) errs.userid = "This field is required";
    if (!name) errs.name = "This field is required";
    if (!company) errs.company = "This field is required";
    if (!contact) errs.contact = "This field is required";
    if (!address) errs.address = "This field is required";
    if (!password) {
      errs.password = "This field is required";
    } else if (password.length < 6) {
      errs.password = "Password needs to be 6 characters or more";
    }
    if (!confirm_password) {
      errs.confirm_password = "This field is required";
    } else if (confirm_password !== password) {
      errs.confirm_password = "Passwords do not match";
    }
    return errs;
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      // UI-only: no persistence. Just advance to the Success screen.
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    loading,
    errorVal,
    companyDDL,
    selectedCompany,
    companydropdown,
    handleChangeEmail,
    handleChangeUserid,
    handleChangeName,
    handleChangeContact,
    handleChangeAddress,
    handleChangePassword,
    handleChangeConfirmPassword,
    email,
    userid,
    name,
    contact,
    address,
    password,
    company,
    companycode,
    companyno,
    companyid,
    confirm_password,
  };
};

export default useForm;
